"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
let PaymentNewVdFilterDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.platformLoading = false;
    this.siteLoading = false;
    this.filterCodeList = ["EBusiness", "IndependentSite"];
    this.platformList = [];
    this.siteList = [];
    this.platform = {};
    this.siteId = {};
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    this._vd_filter_dialog.hide();
    this.$emit("choose", this.siteId);
  }
  close() {
    this._vd_filter_dialog.hide();
  }
  show() {
    return __async(this, null, function* () {
      this._vd_filter_dialog.show();
      this.$nextTick(() => __async(this, null, function* () {
        yield this.getPlatforms();
        yield this.getSites(this.platform.guid);
      }));
    });
  }
  getPlatforms() {
    return __async(this, null, function* () {
      try {
        this.platformLoading = true;
        const result = yield API.get("api://base.auth/api/v7/ebusinesses/list_by_type", {
          params: {
            filter: this.filterCodeList.join(",")
          }
        });
        this.platformList = result.data.datas;
        this.platform = this.platformList[0];
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.platformLoading = false;
      }
    });
  }
  getSites(value) {
    return __async(this, null, function* () {
      try {
        this.siteLoading = true;
        this.siteList = [];
        const result = yield API.get(`api://base.auth/api/v7/ebusinesses/${value}/platforms_list`);
        this.siteList = result.data.datas;
        this.siteId = this.siteList[0];
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.siteLoading = false;
      }
    });
  }
  changePlatform() {
    return __async(this, null, function* () {
      yield this.getSites(this.platform.guid);
    });
  }
};
__decorateClass([
  Ref("vd-filter-dialog")
], PaymentNewVdFilterDialog.prototype, "_vd_filter_dialog", 2);
PaymentNewVdFilterDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], PaymentNewVdFilterDialog);
export {
  PaymentNewVdFilterDialog as default
};
